<!-- Apple-style spinner -->
<div
  *ngIf="type === 'apple'"
  class="apple-spinner"
  [style.width.px]="spinnerSize"
  [style.height.px]="spinnerSize"
  [style.--translate-distance]="'-' + translateDistance + 'px'"
>
  <div
    *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
    [style.width.px]="dashWidth"
    [style.height.px]="dashHeight"
    [style.background-color]="color"
    [attr.data-index]="i"
  ></div>
</div>

<!-- Material spinner -->
<mat-spinner
  *ngIf="type === 'material'"
  [diameter]="spinnerSize"
  [color]="color ? undefined : 'primary'"
  [style.color]="color"
></mat-spinner>
